module.exports = __webpack_public_path__ + "static/media/harvard.a2cbde28.jpg";